export const API_VERSION = "v1.0";
const HOST_URL = `star-omanstg.nuviotech.co`;
const LIVEBASEURL = `https://star-omanstg-api.nuviotech.co`;
const DEVBASEURL = `http://localhost:3800`;
// const DEVBASEURL = `https://cinematic-server-gdc-3.brij.tech`;
// const DEVBASEURL = `http://shringar.brij.tech:3950`;

export const BASEURL =window.location.host === HOST_URL ? LIVEBASEURL : DEVBASEURL;
export const SOCKETURL = BASEURL;
export const IMG_BASEURL = `https://dd3zjslgvteqz.cloudfront.net`;
export const ARENA_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjYwN2VkY2MwLTNjODQtNGRhZC1hY2VmLTBjN2FhYjNmMzU1MyIsImlhdCI6MTYwNjg5MzA0MCwiZXhwIjoxNjA5NDg1MDQwfQ.3dkWIqaDYXjJ0Eayq_nL8Q0rbmqfYcyI3NLZbcbKh8Y`;
export const STARCINEMAS_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImQyM2VlMjEwLTk4Y2EtNDk1Ny1iZTk3LWJhYzRhYjAxNjAzMiIsImlhdCI6MTczMjM4NjY5N30.xratq5iyJxjl0PsOi9S_H6MktOTJAx3tHXP22JxtO88`;
export const TOKEN = STARCINEMAS_TOKEN;
